<template>
  <div class="mobile-control-component">
    <input
      v-model="codeNumber"
      class="input-phone"
      type="text"
      :style="{ color: $store.registratorCaptionColor }"
    >
    <div class="numbers">
      <button
        v-for="number in numbers"
        :key="number.label"
        class="button-number"
        :style="{ borderColor: $store.registratorCaptionColor, opacity: number.opacity }"
        @click="number.action()"
      >
        {{ number.label ? number.label : '' }}
        <template v-if="number.icon">
          <i :class="number.icon" />
        </template>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreRecordControl',
  prop: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      codeNumber: '',
      numbers: [
        {
          label: '1',
          action: this.printNumber.bind(this, '1')
        },
        {
          label: '2',
          action: this.printNumber.bind(this, '2')
        },
        {
          label: '3',
          action: this.printNumber.bind(this, '3')
        },
        {
          label: '4',
          action: this.printNumber.bind(this, '4')
        },
        {
          label: '5',
          action: this.printNumber.bind(this, '5')
        },
        {
          label: '6',
          action: this.printNumber.bind(this, '6')
        },
        {
          label: '7',
          action: this.printNumber.bind(this, '7')
        },
        {
          label: '8',
          action: this.printNumber.bind(this, '8')
        },
        {
          label: '9',
          action: this.printNumber.bind(this, '9')
        },
        {
          label: 'h',
          action: () => {},
          opacity: 0
        },
        {
          label: '0',
          action: this.printNumber.bind(this, '0')
        },
        {
          icon: 'ri-arrow-left-s-line',
          action: this.clearLastNumber.bind()
        },
      ]
    }
  },
  watch: {
    codeNumber: {
      handler() {
        this.$emit('input', this.codeNumber);

        const spaces = new Set([3, 7, 10, 13]);

        if (spaces.has(this.codeNumber.length)) {
          this.codeNumber += ' ';
        }
      },
      immediate: true
    }
  },
  methods: {
    printNumber(number) {
      if (this.codeNumber.length <= 6) this.codeNumber += number;
    },
    clearLastNumber() {
      if (this.codeNumber.length === 3) return;

      if (this.codeNumber[this.codeNumber.length - 1] === ' ') {
        this.codeNumber = this.codeNumber.slice(0, -2);
      } else {
        this.codeNumber = this.codeNumber.slice(0, -1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-control-component {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.button-number,
.input-phone {
  font-feature-settings: normal;
}

.numbers {
  width: 304px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: min(48px, 4.6875vh);

  .button-number {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: none;
    background: #FFFFFF;
    box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074), 0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    font-size: 64px;
    font-weight: 400;

    i {
      font-size: 56px;
      margin-right: 0;
    }
  }
}

.input-phone {
  padding: 18px 0 18px 45px;
  font-size: 64px;
  background: rgba(239, 239, 244, 0.3);
  border-radius: 20px;
  width: 360px;
  height: auto;
  border: none;
  pointer-events: none;
}
</style>
